import { Box, Chip } from "@mui/material";
import { Flex, HStack } from "@zfp-akademie-a-s/zfp-design";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { CoinsIcon } from "Components/_Shared/Icons/Icons";
import { useGetGoalModelingDetail } from "Infrastructure/ApiZfp/AnalyzerApi";
import type { AllocatedAmount, GoalOverview } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { useContext } from "react";
import { GoalLabel } from "../_Shared/Goals/GoalLabel";
import { GoalFulfillmentItemFundsTooltip } from "./GoalFulfillmentItemFundsTooltip";

type Props = {
  goal: GoalOverview;
};

const getOneTimeFundsData = (allocatedAmount: AllocatedAmount[]): string => {
  if (allocatedAmount.length === 0) return formatCurrency(0, undefined);

  const sumValue = allocatedAmount.reduce((total, item) => {
    return total + (item.amount?.value ?? 0);
  }, 0);

  return formatCurrency(sumValue, allocatedAmount[0].amount?.currencyCode);
};

export const GoalFulfillmentItem = ({ goal }: Props) => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const { data: goalModeling } = useGetGoalModelingDetail(analysisId, versionId, goal.guid, {
    query: { enabled: !!goal.guid },
  });

  if (!goalModeling) return null;

  return (
    <Box pl={Spacing.L} pt={Spacing.XL}>
      <GoalLabel
        goal={goal}
        extra={
          <Flex gap={Spacing.M} flexWrap={"wrap"}>
            <Chip
              size="small"
              icon={<CoinsIcon />}
              label={
                <HStack component="span" spacing={Spacing.S} alignItems="center">
                  <span>{`${t(Resources.AnalysisDetail.GoalsFulfillment.RegularFunds)}:`}</span>
                  <Box component="span" fontWeight={300}>
                    {formatCurrency(goalModeling.allocatedAmount?.amount?.value, goalModeling.allocatedAmount?.amount?.currencyCode)}
                  </Box>
                </HStack>
              }
            />
            <Chip
              size="small"
              icon={<CoinsIcon />}
              label={
                <HStack component="span" spacing={Spacing.S} alignItems="center">
                  <span>{`${t(Resources.AnalysisDetail.GoalsFulfillment.OneTimeFunds)}:`}</span>
                  <Box component="span" fontWeight={300}>
                    {getOneTimeFundsData(goalModeling.allocatedAssetAmounts)}
                  </Box>
                  <Box component="span" onClick={(e) => e.stopPropagation()}>
                    <GoalFulfillmentItemFundsTooltip allocatedAssetAmounts={goalModeling.allocatedAssetAmounts} />
                  </Box>
                </HStack>
              }
            />
          </Flex>
        }
      />
    </Box>
  );
};
